/* eslint-disable import/prefer-default-export */
import { useContext, useEffect, useRef } from "react";
import addNotification from "react-push-notification";
import { useQuery, useQueryClient } from "react-query";
import { SocketContext } from "../services/socket";
import { shouldReceiveProgramMessage } from "./programMessageEvents";

import { getMessages } from "../api/ProgramMessages";

const key = "program-messages";
const MESSAGE_SONG_URL =
  "https://public-resourses-files.s3.us-east-2.amazonaws.com/AUDIO/message.mp3";

export function useProgramMessages(page) {
  return useQuery([key, page], () => getMessages(page), {
    refetchOnWindowFocus: false,
  });
}

const notificationPush = () => {
  addNotification({
    title: "Corporación de ayuda",
    message: "Tiene un nuevo mensaje, verifique el detalle en sistema.",
    duration: 15000,
    native: true,
  });
  document.title = "Nueva notificación";
};

export function useInvalidateProgramMessages({
  user,
  setPage,
  setHasNewMessages,
  programId,
  adminMode,
}) {
  const audioRef = useRef(null);
  const socket = useContext(SocketContext);
  const queryClient = useQueryClient();

  useEffect(() => {
    audioRef.current = new Audio(MESSAGE_SONG_URL);

    return () => {
      audioRef.current?.pause();
      audioRef.current = null;
    };
  }, []);

  useEffect(() => {
    const onRefreshMessages = (data) => {
      if (shouldReceiveProgramMessage(user, data, adminMode)) {
        setPage(0);
        queryClient.invalidateQueries([key]);
        if (programId !== data?.programId) {
          audioRef.current?.play().catch(() => {});
          setHasNewMessages(true);
          notificationPush();
        }
      }
    };

    socket.on("REFRESH_MESSAGES", onRefreshMessages);

    return () => {
      socket.off("REFRESH_MESSAGES", onRefreshMessages);
    };
  }, [
    adminMode,
    programId,
    queryClient,
    setHasNewMessages,
    setPage,
    socket,
    user,
  ]);
}
